<template>
  <div class="redirect">
    <h3>{{ data.title }}</h3>
    <p>{{ data.description }}</p>
    <div
      style="margin-top: 5px;
    flex-direction: row;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;"
    >
      <el-button
        style="margin-top: 5px;"
        size="mini"
        @click="$router.push({ name: item.route })"
        v-for="(item, index) in data.routes"
        :key="index"
      >
        {{ item.title }}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Redirect",
  props: ["data"],
};
</script>

<style scoped>
.redirect {
  background-color: #f5f7fa;
  padding: 7px 13px;
  border-radius: 3px;
  margin-bottom: 10px;
}
p {
  margin: 0px;
  font-size: 12px;
}
h3 {
  font-size: 15px;
  margin: 0px;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Redirect.vue